import React, { CSSProperties, useCallback } from 'react';
import { ReactComponent as BigX } from 'assets/empty-block.svg';
import { getColorCssString, getDefaultDesignerColor } from 'utils/ColorUtils';
import { DesignerColor } from '@decisions/server/Decisions/Silverlight/UI/Utilities';
import { SubCalcFieldDefinition } from '@decisions/server/DecisionsFramework/Design/Report/SubcalcFields/SubCalcFieldDefinition';
import { IconButton } from 'components/buttons/IconButton';

interface IChartSeriaColorPanelProps {
  clearColor: (seriaNumber: number) => void;
  openColorPickerDialog: (e: React.MouseEvent<Element>, seriaNumber: number) => void;
  seria: SubCalcFieldDefinition;
  hideColorOption: boolean;
  seriaNumber: number;
}

export function ChartSeriaColorPanel({
  seria,
  clearColor,
  openColorPickerDialog,
  seriaNumber,
  hideColorOption,
}: IChartSeriaColorPanelProps) {
  const selectColorClick = useCallback((e: React.MouseEvent<Element>) => openColorPickerDialog(e, seriaNumber), [
    openColorPickerDialog,
    seriaNumber,
  ]);

  const clearColorClick = useCallback(() => clearColor(seriaNumber), [clearColor, seriaNumber]);

  return (
    <div className="dpc-chart-series-editor__color-panel">
      {!hideColorOption && (
        <>
          <span className="dpc-chart-series-editor__color">
            <BigX className="dpc-chart-series-editor__x-icon" />
            <div
              className="dpc-chart-series-editor__color-picker"
              style={getCollorStyle(seria.Color || getDefaultDesignerColor())}
              onClick={selectColorClick}
            />
          </span>
          <IconButton
            iconClassName="dpc-chart-series-editor__more-icon"
            onClick={selectColorClick}
            title="Select Color"
          />
          <IconButton
            title="Clear Color"
            iconClassName="dpc-chart-series-editor__clear-icon"
            onClick={clearColorClick}
          />
        </>
      )}
    </div>
  );
}

function getCollorStyle(color: DesignerColor): CSSProperties {
  return {
    background: getColorCssString(color),
  };
}
